export const webhookEvents = ['consent_withdrawn', 'consent_revoked', 'consent_obtained'];
